
import React from "react";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";

interface KeywordsSectionProps {
  keywords: string[];
  updateBusinessData: (key: string, value: any) => void;
}

const KeywordsSection: React.FC<KeywordsSectionProps> = ({ 
  keywords,
  updateBusinessData
}) => {
  if (!keywords || keywords.length === 0) return null;
  
  return (
    <div className="space-y-2">
      <Label>Keywords</Label>
      <div className="flex flex-wrap gap-2 p-4 bg-muted/10 rounded-lg">
        {keywords.map(keyword => (
          <Badge key={keyword} variant="secondary">
            {keyword}
          </Badge>
        ))}
      </div>
    </div>
  );
};

export default KeywordsSection;
